import { render, staticRenderFns } from "./TaggingComponent.vue?vue&type=template&id=c5748926&"
import script from "./TaggingComponent.vue?vue&type=script&lang=js&"
export * from "./TaggingComponent.vue?vue&type=script&lang=js&"
import style0 from "./TaggingComponent.vue?vue&type=style&index=0&id=c5748926&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports